module.exports = __webpack_public_path__ + "img/green_142.57a0fe44.png";